import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { api } from "@/lib/api";

function formatError(e) {
  const d = e.response?.data?.detail;
  if (typeof d === "string") return d;
  if (Array.isArray(d)) return d.map((x) => x.msg).join(" ");
  return "Login failed. Check your credentials.";
}

export default function AdminLogin() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError("");
    try {
      const { data } = await api.post("/auth/login", { email: email.trim().toLowerCase(), password: password.trim() });
      localStorage.setItem("bsg_admin_token", data.token);
      navigate("/admin/dashboard");
    } catch (err) {
      setError(formatError(err));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div data-testid="admin-login-page" className="min-h-screen bg-ink flex items-center justify-center px-6">
      <form onSubmit={submit} className="w-full max-w-sm border border-white/10 bg-surface p-10">
        <span className="font-mono text-[10px] tracking-[0.35em] uppercase text-gold">BSGOTECH</span>
        <h1 className="font-serif text-3xl text-ivory mt-3">Founder CMS</h1>
        <p className="text-sm text-white/40 mt-1 mb-8">Sign in to manage the website.</p>
        {error && <p data-testid="admin-login-error" className="mb-4 text-sm text-red-400">{error}</p>}
        <label className="block font-mono text-[10px] tracking-[0.25em] uppercase text-white/40 mb-2">Email</label>
        <input data-testid="admin-email-input" type="email" required value={email} onChange={(e) => setEmail(e.target.value)}
          className="w-full bg-ink border border-white/10 px-4 py-3 text-sm text-ivory focus:border-gold/60 focus:outline-none mb-5" />
        <label className="block font-mono text-[10px] tracking-[0.25em] uppercase text-white/40 mb-2">Password</label>
        <input data-testid="admin-password-input" type="password" required value={password} onChange={(e) => setPassword(e.target.value)}
          className="w-full bg-ink border border-white/10 px-4 py-3 text-sm text-ivory focus:border-gold/60 focus:outline-none mb-8" />
        <button data-testid="admin-login-btn" disabled={loading} className="w-full py-3.5 bg-gold text-ink font-mono text-[11px] tracking-[0.2em] uppercase hover:bg-gold-light transition-colors disabled:opacity-50">
          {loading ? "Signing in…" : "Sign In"}
        </button>
        <a href="/" className="block mt-6 text-center font-mono text-[10px] tracking-[0.2em] uppercase text-white/30 hover:text-gold transition-colors">← Back to website</a>
      </form>
    </div>
  );
}
